<template>
  <div class="home-wrap">
    <div class="top-welcome">
      <img class="img" src="../../assets/images/pic/home_show.png">
      <p class="text">欢迎来到衣加加-人才交易管理后台</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'homeIndex',
    data() {
      return {
       
      }
    },
    created() {
     
    },
    methods: {
      
    }
  }
</script>

<style scoped lang="scss">
.home-wrap {
  margin: 10px 10px 0;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  height: -moz-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
  height: calc(100vh - 84px);
  .top-welcome {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    .img {
      margin-top: -32px;
      width: 480px;
    }
    .text {
      margin-top: 32px;
      font-size: 24px;
      color: #333;
      letter-spacing: 1px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue